import React, {Component} from 'react';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import * as ROUTES from '../../Routes';
import {Button, KIND, SIZE} from 'baseui/button';
import GooglePlayBadge from '../../images/platforms/android/google-play-badge.png';

const centerProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

class Android extends Component {
    
    renderDetails = () => {
        return <FlexGrid>
            <FlexGridItem>
                <FlexGrid backgroundColor={'primaryB'} style={{padding: '20px'}}>
                    <FlexGridItem><HeadingSmall margin={0}>EncLock Android</HeadingSmall></FlexGridItem>
                    <FlexGridItem>
                        <ParagraphLarge>EncLock is now available on the Google Play Store, bringing its security features to Android users. Protect your files, passwords, notes, and other sensitive information on your phone or tablet with ease. While cloud sync is not yet implemented, EncLock continues to deliver top-tier protection for your personal data locally on your Android devices.</ParagraphLarge>
                        <ParagraphLarge>Head to Google Play and install EncLock today to keep your digital life private and protected.</ParagraphLarge>
                    </FlexGridItem>
                    <FlexGridItem {...centerProps}>
                        <Button href={ROUTES.ENCLOCK_ANDROID_INSTALL} $as={'a'} target={"_blank"} size={SIZE.mini} kind={KIND.tertiary}><img src={GooglePlayBadge} width={180} alt="Google Play"/></Button>
                    </FlexGridItem>

                </FlexGrid>
            </FlexGridItem>
        </FlexGrid>
    };

    render = () => {
        return <div>
            {this.renderDetails()}
        </div>
    };
}

export default Android;